module.exports = __webpack_public_path__ + "img/glitter_9.513a1b3c.jpg";